import t from 'tcomb';
import jsdk from '../../jsdk';
import Field_Style from '../../web/domain/style/Field_Style';
import Field_Target from '../../web/domain/Field_Target';
import countries from '../../web/domain/countries';
import UUID from '../../web/domain/UUID';
import Validation from '../../web/domain/Validation';
import Verified from '../../web/domain/Verified';
import Rule from '../../web/domain/Rule';
import get_bundle from '../../web/domain/get_bundle';

const _std_table = (data) => {
  return '<table class="std-table">' + data.map(function(pair) {
    jsdk.assert(!jsdk.Nil.is(pair[0]));
    return pair[1] ? '<tr><td class="std-table-label">' + pair[0] + '</td><td class="std-table-value">' + jsdk.escape_html(pair[1]) + '</td></tr>' : '';
  }).join('') + '</table>';
};

const Field_Component_Input = t.struct({
  id: UUID,
  style: Field_Style,
  targets: t.list(Field_Target),
  owner: t.Str
}, 'Field_Component_Input');

/*
function Field_Component_Input(id, style, targets, owner) {
  jsdk.assert(jsdk.UUID.is(id));
  jsdk.assert(Field_Style.is(style));
  jsdk.assert(jsdk.List(Field_Target).is(targets));
  jsdk.assert(jsdk.Str.is(owner));
  this.type = 'reducer/field';
  this.id = id;
  this.style = style;
  this.targets = targets;
  this.owner = owner;
  return jsdk.freeze(this);
}
Field_Component_Input.is = function(x) {
  return x instanceof Field_Component_Input;
};
Field_Component_Input.of = function(x) {
  return new Field_Component_Input(
    jsdk.UUID.of(x.id),
    Field_Style.of(x.style),
    jsdk.List(Field_Target).of(x.targets),
    jsdk.Str.of(x.owner)
  );
};
*/
Field_Component_Input.prototype.to_html = function(value, locale, context) {
  //jsdk.assert(jsdk.Obj.is(context));
  //jsdk.assert(jsdk.Obj.is(context.fields));
  var bundle = get_bundle(locale).reducer;
  var data = this.targets.map(function(target) {
    return [
      '<strong>' + bundle.targets[target.field] + '</strong>',
      context.fields[target.field]
    ];
  });
  var targets = _std_table(data);

  var styles = jsdk.split_margins(this.style);

  var html = jsdk.dom.div(jsdk.template(bundle.field)({
    targets: targets,
    owner: this.owner
  }), {
    id: this.id,
    style: this.style
  });

  return jsdk.Form.wrap_input(this.id, html, styles.margins);
};


Field_Component_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Field_Component_Input.prototype.value = function(locale, context) {
  let ret = null;
  const isMobileRequest = () => {
    return this.targets.some((target) => {
      return target.field === 'mobile';
    });
  };
  if ( Verified.is(context.user) && isMobileRequest() && context.user.mobile_country !== locale.country ) {
    const prefix = countries.area(locale.country);
    ret = new Validation({x: null, rule: new Rule({name: 'mobile_number_not_allowed', args: [prefix]})});
    this.set_error(ret.rule ? ret.rule.localize(locale) : '');
  }
  if (!ret) {
    ret = new Validation({x: this.targets.map(function(target) {
      return [target.id, context.user[target.field]];
    }), rule: null});
  }
  return ret;
};
jsdk.Form.add_input('reducer/field', Field_Component_Input);

export default Field_Component_Input;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/reducer/Field_Component_Input.js
 **/